/**
 * Basic Smallscreen navigation (show/hide via toggle button)
 *
 * @param {string} toggleButtonSelector - selector for toggle button
 */

import { toggleIt } from './utils/showHide';

export const navToggle = (toggleButtonSelector = '#ghwp-main-toggle') => {
    const mainMenu = document.querySelector(toggleButtonSelector);

    mainMenu &&
        mainMenu.addEventListener('click', function () {
            toggleIt(this);
        });
};
